module.exports = "/cyber/_next/static/images/mtsd-banner-mobile-6def14d2d4d4becb0ebc76c37cf97920.webp";